





























import { defineComponent, PropType } from "@vue/composition-api";
import { CreditCardAssignment } from "@scrile/api-provider/dist/api/CreditCardAssignmentsProvider";
import useSystemSettings from "@/hooks/useSystemSettings";
import { getAvailableSystems } from "@/lib/paymentSystemsHelpers";
import config from "@/config";
import { PurchaseType } from "@/const";
import BaseButton from "@/components/BaseButton";
import CardItem from "../CardItem";

export default defineComponent({
  name: "CardListView",
  components: { CardItem, BaseButton },
  props: {
    cards: { type: Array as PropType<CreditCardAssignment[]>, required: true },
  },
  setup() {
    const { publicPaymentSystems } = useSystemSettings();

    const availablePaymentSystemsInfo = getAvailableSystems(publicPaymentSystems.value, PurchaseType.TOP_UP).map(
      ({ system, integration }) => ({
        id: system.id,
        name: integration.name,
      })
    );
    const findPaymentSystemInfoById = (id: string) => availablePaymentSystemsInfo.find(i => i.id === id);

    return {
      config,
      availablePaymentSystemsInfo,
      findPaymentSystemInfoById,
    };
  },
});
